// ----------------------------------------------------------------------
export function appBar(_theme) {
    return {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    boxShadow: "none",
                },
            },
        },
    };
}
